<div class="bg-white">
    <section class="main-grid">
        <header class="relative my-6 flex items-center justify-center md:my-0 md:block">
            <a class="absolute left-4 inline-block h-9 w-9 md:hidden" [routerLink]="'/' | localize">
                <mat-icon
                    class="pn-app-light:text-primary pn-light:text-primary text-secondary"
                    svgIcon="ticket-back"></mat-icon>
            </a>
            <h1 class="text-center text-base font-medium md:text-left md:text-5xl">
                {{ 'FEEDBACK_PAGE_TITLE' | translate }}
            </h1>
        </header>

        <ion-button
            class="row-start-3 mx-4 mb-9 md:col-start-1 md:row-start-auto md:mx-0 md:mt-7 md:w-full"
            *ngIf="showSubmitBtn"
            [disabled]="feedbackForm.invalid || !termsAgreed || !recaptchaValue"
            [attr.aria-label]="'FEEDBACK_FORM_SAVE' | translate"
            (click)="submitFeedback()"
            size="large"
            color="secondary">
            <ion-label class="text-base font-bold normal-case">
                {{ 'FEEDBACK_FORM_SAVE' | translate }}
            </ion-label>
        </ion-button>

        <main class="md:col-start-2 md:row-start-1 md:row-end-4">
            <mat-tab-group
                class="feedback-tabs"
                [dynamicHeight]="true"
                (selectedTabChange)="onTabChange($event)"
                color="none"
                animationDuration="0ms">
                <mat-tab [aria-label]="'FEEDBACK_SEND_TITLE' | translate">
                    <ng-template matTabLabel>
                        <p class="text-sm font-semibold uppercase leading-4">{{ 'FEEDBACK_SEND_TITLE' | translate }}</p>
                    </ng-template>
                    <ng-template matTabContent>
                        <div class="bg-[#F0F0F0] pt-4 dark:bg-inherit md:rounded-lg md:p-4">
                            <form class="bg-white p-4 md:shadow-sm" [formGroup]="feedbackForm">
                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>
                                        {{ 'FEEDBACK_FORM_NAME' | translate }}
                                    </mat-label>
                                    <input formControlName="name" required matInput />
                                    <mat-error *ngIf="feedbackForm.controls.name.invalid">
                                        {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>
                                        {{ 'FEEDBACK_FORM_EMAIL' | translate }}
                                    </mat-label>
                                    <input formControlName="email" required matInput />
                                    <mat-error *ngIf="feedbackForm.controls.email.invalid">
                                        {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>
                                        {{ 'FEEDBACK_FORM_PH_SELECT_CATEGORY' | translate }}
                                    </mat-label>
                                    <mat-select class="py-0" disableOptionCentering formControlName="category" required>
                                        <mat-option *ngFor="let category of feedbackCategories" [value]="category">
                                            {{ category.translation }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="feedbackForm.controls.category.invalid">
                                        {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>{{ 'FEEDBACK_FORM_MESSAGE' | translate }}</mat-label>
                                    <textarea
                                        rows="7"
                                        formControlName="message"
                                        required
                                        matInput
                                        aria-describedby="feedback-message-hint"></textarea>
                                    <mat-hint id="feedback-message-hint">
                                        {{ feedbackForm.controls.message.value?.length ?? 0 }} / {{ maxLength }}
                                    </mat-hint>
                                    <mat-error *ngIf="feedbackForm.controls.message.invalid">
                                        {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                    </mat-error>
                                </mat-form-field>

                                <div class="flex items-center justify-between">
                                    <span>
                                        {{ 'CHOOSE_FILE' | translate }}
                                    </span>

                                    <ion-button
                                        *ngIf="selectedFile === null"
                                        [attr.aria-label]="'ADD' | translate"
                                        (click)="fileInput.click()"
                                        size="large"
                                        color="secondary">
                                        <ion-label class="text-base font-bold normal-case">
                                            {{ 'ADD' | translate }}
                                        </ion-label>
                                    </ion-button>

                                    <div class="flex items-center" *ngIf="selectedFile !== null">
                                        <h4 class="my-3 inline-block">{{ selectedFile.name }}</h4>
                                        <mat-icon class="m-4 cursor-pointer text-primary" (click)="resetFile()">
                                            close
                                        </mat-icon>
                                    </div>
                                    <input
                                        #fileInput
                                        (change)="onFileSelected($event)"
                                        hidden
                                        type="file"
                                        accept="image/png, image/jpeg, .pdf" />
                                </div>

                                <ridango-terms-and-conditions-block
                                    [termsAgreed]="termsAgreed"
                                    [termsUrl]="termsUrl"
                                    [terms]="terms"
                                    [locale]="locale"
                                    (onAgreementChange)="termsAgreed = $event">
                                </ridango-terms-and-conditions-block>

                                <re-captcha
                                    #recaptcha
                                    [formControlName]="recaptcha"
                                    [siteKey]="siteKey"
                                    (resolved)="resolved($event)">
                                </re-captcha>
                            </form>
                        </div>
                    </ng-template>
                </mat-tab>

                <mat-tab
                    *ngIf="feedbackHistoryList && feedbackHistoryList.length > 0"
                    [aria-label]="'FEEDBACK_HISTORY_TITLE' | translate">
                    <ng-template matTabLabel>
                        <p class="text-sm font-semibold uppercase leading-4">
                            {{ 'FEEDBACK_HISTORY_TITLE' | translate }}
                        </p>
                    </ng-template>
                    <ng-template matTabContent>
                        <rwidget-feedback-history
                            [feedbackHistoryList]="feedbackHistoryList"></rwidget-feedback-history>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </main>
    </section>
</div>
